import React from "react";
import AnimatedBody from "../../animations/AnimatedBody";

interface Position {
  title: string;
  date: string;
  description: string;
  impact: string[];
}

interface Job {
  company: string;
  positions: Position[];
}

const JobCard = ({ job }: { job: Job }) => {
  if (!job) return null;

  return (
    <div className="mx-auto w-[100%] justify-center">
      <div className="mb-10 flex w-[100%] flex-col gap-4 leading-relaxed tracking-wide text-[#e4ded7]">
        <AnimatedBody
          delay={0.2}
          text={job.company}
          className="text-2xl font-bold text-[#9708de] sm:text-3xl"
        />
        {job.positions.map((position, i) => (
          <React.Fragment key={i}>
            <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-0">
              <AnimatedBody
                delay={0.3}
                text={position.title}
                className="text-base font-bold sm:text-xl"
              />
              <AnimatedBody
                delay={0.3}
                text={position.date}
                className="text-sm italic text-[#b0a9a0] sm:mx-2 sm:text-lg"
              />
            </div>
            <span className="text-sm sm:text-base">{position.description}</span>
            <div className="flex flex-col gap-2 text-xs sm:text-sm">
              {position.impact.map((imp, j) => (
                <span key={j}>● {imp}</span>
              ))}
            </div>
            <hr className="mt-2 border-[#ffffff1a]" />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default JobCard;
